import React from 'react'
import SectionTitle from 'src/components/SectionTitle'
import InputWrapper from 'src/components/InputWrapper'
import InputTime from 'src/components/tabs/InputTime'
import { DateInput } from 'semantic-ui-calendar-react'
import moment from 'moment'
import { AppContext } from 'src/context/AppContext'

const dateFormat = 'YYYY-MM-DD'

class DontRepeat extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      date: '',
      currentDate: moment()
    }
  }

  render () {
    return (
      <AppContext.Consumer>
        {({ state, actions }) => (
          <div>
            <InputWrapper>
              <SectionTitle>日付</SectionTitle>
              <DateInput
                name={'date'}
                dateFormat={dateFormat}
                value={state.date}
                placeholder={dateFormat}
                iconPosition={'left'}
                onChange={actions.onChangeInput}
                minDate={this.state.currentDate} // 今日
                // maxDate={''} 指定しない
                marked={[this.state.currentDate]}
                markColor={'blue'}
                closable
                animation={'none'}
                hideMobileKeyboard
              />
            </InputWrapper>
            <InputTime />
          </div>
        )}
      </AppContext.Consumer>
    )
  }
}

export default DontRepeat
